export enum DESTINATION_MODES {
	ADD = 'add',
	COPY = 'copy',
	MOVE = 'move',
	RESTORE = 'restore',
	ADDTOLIBRARY = 'addToLibrary'
}
